import { createGetEndpoint } from '@sonar-software/sonar-http';

export const getVersion = createGetEndpoint<void, string>('/api/v2/version');
